import _axios from "../../../../httpService";
import { prefixUrl } from "../../../../utils/utilsData";
import { toast } from "react-toastify";

const showErrorsSequentially = (errors) => {
  const errorMessages = Object.values(errors);

  errorMessages.forEach((message, index) => {
    setTimeout(() => {
      toast.error(message, {
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: 5000,
      });
    }, index * 700);
  });
};


const validateData = (data, file) => {
  const errors = {};

  if (!data.fullName_1.trim()) {
    errors.fullName_1 = 'نام کامل (۱) الزامی است';
  }

  if (!data.phoneNumber_1.trim()) {
    errors.phoneNumber_1 = 'شماره تلفن (۱) الزامی است';
  }

  // if (!data.national_id_1.trim()) {
  //   errors.national_id_1 = 'کد ملی (۱) الزامی است';
  // }

  if (!data?.groupFullName.trim()) {
    errors.groupFullName = 'نام کامل مجموعه الزامی است';
  }

  // if (!data?.ownerShipType.trim()) {
  //   errors.ownerShipType = 'مالکیت مجموعه الزامی است';
  // }

  // if (!data?.emailAddress.trim()) {
  //   errors.emailAddress = 'ایمیل فعال الزامی است';
  // }

  // if (data?.postalCode.length !== 10) {
  //   errors.postalCode = 'کد پستی باید 10 کاراکتر باشد';
  // }

  // if (!data?.telephone.trim()) {
  //   errors.telephone = 'خط ثابت الزامی است';
  // }

  // if (!data?.address.trim()) {
  //   errors.address = 'آدرس الزامی است';
  // }

  // if (!data?.activityType.trim()) {
  //   errors.activityType = 'نوع زمینه فعالیت مجموعه الزامی است';
  // }

  // if (!data?.activityDescription.trim()) {
  //   errors.activityDescription = 'شرح مختصر زمینه های فعالیت مجموعه الزامی است';
  // }

  // if (data.hasSite && !data.siteLink.trim()) {
  //   errors.siteLink = 'لینک سایت الزامی است';
  // }

  // if (data.hasDomain && !data.domainName.trim()) {
  //   errors.domainName = 'نام دامنه الزامی است';
  // }

  // if (data.paymentGateway && !data.bankName.trim()) {
  //   errors.bankName = 'نام بانک الزامی است';
  // }

  // if (data.paymentGateway && data.shebaNumber.length !== 24) {
  //   errors.shebaNumber = 'شماره شبا باید ۲۴ کاراکتر باشد';
  // }

  // if (data.paymentGateway && !data.accountNumber.trim()) {
  //   errors.accountNumber = 'شماره حساب الزامی است';
  // }

  // if (data.hasAgent && !data.agentAddress.trim()) {
  //   errors.agentAddress = 'آدرس نماینده در صورت فعال بودن نماینده الزامی است';
  // }

  // if (data.mode === "add" && file?.nationalCard.length === 0) {
  //   errors.nationalCard = 'کارت ملی باید یک فایل معتبر باشد';
  // }

  // if (data.mode === "add" && data.electronicSymbol === 1 && data?.personType === "حقیقی" && file?.duty.length === 0) {
  //   errors.birthCertificate = 'مدرک وضعیت نظام وظیفه باید یک فایل معتبر باشد';
  // }

  // if (data.mode === "add" && data.electronicSymbol === 1 && data?.personType === "حقیقی" && file?.birthCertificate.length === 0) {
  //   errors.duty = 'شناسنامه باید یک فایل معتبر باشد';
  // }

  // if (data.mode === "add" && data.electronicSymbol === 1 && data?.personType === "حقوقی" && file?.mainStatute.length === 0) {
  //   errors.mainStatute = 'اصل اساسنامه باید یک فایل معتبر باشد';
  // }

  // if (data.electronicSymbol === 1 && !data?.electronicSymbolStatus.trim()) {
  //   errors.electronicSymbolStatus = 'وضعیت اینماد الزامی است';
  // }

  // if (data.paymentGateway === 1 && !data?.paymentGatewayStatus.trim()) {
  //   errors.paymentGatewayStatus = 'وضعیت درگاه پرداخت الزامی است';
  // }

  // if (data.phoneNumber_1 && data.phoneNumber_1.length !== 11) {
  //   errors.phoneNumber_1 = 'شماره تلفن (۱) باید 11 رقم باشد';
  // }

  // if (data.phoneNumber_2 && data.phoneNumber_2.length !== 11) {
  //   errors.phoneNumber_2 = 'شماره تلفن (۲) باید 11 رقم باشد';
  // }

  // if (data.national_id_1 && !/^\d{10}$/.test(data.national_id_1)) {
  //   errors.national_id_1 = 'کد ملی (۱) باید دقیقاً ۱۰ رقم باشد';
  // }

  // if (data.national_id_2 && !/^\d{10}$/.test(data.national_id_2)) {
  //   errors.national_id_2 = 'کد ملی (۲) باید دقیقاً ۱۰ رقم باشد';
  // }

  if (!data?.status) {
    errors.national_id_2 = 'تعیین وضعیت درخواست الزامی است';
  }

  return errors;
};

export const SubmitDataHandler = async (sendData, initialData, file, navigateTo, deletedFiles, setIsPending) => {

  const errors = validateData(sendData, file);

  if (Object.keys(errors).length === 0) {
    const formData = new FormData();

    formData.append('mode', sendData?.mode);
    formData.append('request_id', sendData?.request_id);
    formData.append('leadId', sendData?.leadId);
    formData.append('fullName_1', sendData?.fullName_1);
    formData.append('phoneNumber_1', sendData?.phoneNumber_1);
    formData.append('national_id_1', sendData?.national_id_1);
    formData.append('fullName_2', sendData?.fullName_2);
    formData.append('phoneNumber_2', sendData?.phoneNumber_2);
    formData.append('national_id_2', sendData?.national_id_2);
    formData.append('groupFullName', sendData?.groupFullName);
    formData.append('ownerShip', sendData?.ownerShip);
    formData.append('emailAddress', sendData?.emailAddress);
    formData.append('postalCode', sendData?.postalCode);
    formData.append('telephone', sendData?.telephone);
    formData.append('address', sendData?.address);
    formData.append('ownerShipType', sendData?.ownerShipType);
    formData.append('activityType', sendData?.activityType);
    formData.append('activityDescription', sendData?.activityDescription);
    formData.append('hasSite', sendData?.hasSite);
    formData.append('siteLink', sendData?.siteLink);
    formData.append('hasDomain', sendData?.hasDomain);
    formData.append('domainName', sendData?.domainName);
    formData.append('electronicSymbol', sendData?.electronicSymbol);
    formData.append('paymentGateway', sendData?.paymentGateway);
    formData.append('economicId', sendData?.economicId);
    formData.append('bankName', sendData?.bankName);
    formData.append('shebaNumber', sendData?.shebaNumber);
    formData.append('accountNumber', sendData?.accountNumber);
    formData.append('hasAgent', sendData?.hasAgent);
    formData.append('agentAddress', sendData?.agentAddress);
    formData.append('googleMap', sendData?.googleMap);
    formData.append('status', sendData?.status);
    formData.append('electronicSymbolStatus', sendData?.electronicSymbolStatus);
    formData.append('paymentGatewayStatus', sendData?.paymentGatewayStatus);
    formData.append('personType', sendData?.personType);
    formData.append('factorDescription', sendData?.factorDescription);
    formData.append('agreedPrice', sendData?.agreedPrice);
    formData.append('nationalCard', file?.nationalCard);
    if (file?.license.length !== 0) {
      formData.append('license', file?.license);
    }
    if (sendData.electronicSymbol === 1 && sendData?.personType === "حقیقی" && file?.birthCertificate.length !== 0) {
      formData.append('birthCertificate', file?.birthCertificate);
    }
    if (sendData.electronicSymbol === 1 && sendData?.personType === "حقیقی" && file?.duty.length !== 0) {
      formData.append('duty', file?.duty);
    }
    if (sendData.electronicSymbol === 1 && sendData?.personType === "حقوقی" && file?.mainStatute.length !== 0) {
      formData.append('mainStatute', file?.mainStatute);
    }
    if (file?.lastNames.length !== 0) {
      formData.append('lastNames', file?.lastNames);
    }
    if (file?.lastActivities.length !== 0) {
      formData.append('lastActivities', file?.lastActivities);
    }
    if (file?.lastAddress.length !== 0) {
      formData.append('lastAddress', file?.lastAddress);
    }

    let modules = []
    initialData?.modules.forEach((item) => {
      if (+item?.check === 1) {
        modules.push(item);
      }
    })
    modules.forEach((item, index) => {
      formData.append(`modules[${index}][id]`, item?.id);
      formData.append(`modules[${index}][title]`, item?.title);
    });

    let socialMedia = []
    initialData?.socialMedia.forEach((item) => {
      if (item?.link !== "") {
        socialMedia.push(item);
      }
    })
    socialMedia.forEach((item, index) => {
      formData.append(`socialMedia[${index}][id]`, item?.id);
      formData.append(`socialMedia[${index}][title]`, item?.title);
      formData.append(`socialMedia[${index}][link]`, item?.link);
    });

    if (deletedFiles.length > 0) {
      deletedFiles.forEach((item, index) => {
        formData.append(`deleted_files[${index}]`, item);
      });
    }

    const response = await _axios.post(prefixUrl() + "/hiSite/?request=submitHiSiteRequest", formData)
    if (response.data?.status) {
      toast.success(response?.data?.message)
      navigateTo(-1)
    } else {
      toast.error(response?.data?.message)
      setIsPending(false)
    }
  } else {
    showErrorsSequentially(errors);
    setIsPending(false)
  }
}